import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import GenerativeModelsTabState from './GenerativeModelsTabState';
import GenerativeModelsView from './GenerativeModelsView';

export class GenerativeModelsTabView extends BufferTabView<GenerativeModelsTabState> {
  reactRoot: ReactDOM.Root | null = null;

  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const currentEntityType = this.model.get('currentEntityType');
    this.reactRoot = renderToDOM(
      <GenerativeModelsView
        currentEntityType={currentEntityType}
        targetId={this.model.get('currentEntityId')}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}
GenerativeModelsTabView.initClass();

export default GenerativeModelsTabView;
